function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.05 12.95L7.2 14.8C6.81 15.19 6.19 15.19 5.79 14.81C5.68 14.7 5.57 14.6 5.46 14.49C4.43 13.45 3.5 12.36 2.67 11.22C1.85 10.08 1.19 8.94 0.71 7.81C0.24 6.67 0 5.58 0 4.54C0 3.86 0.12 3.21 0.36 2.61C0.6 2 0.98 1.44 1.51 0.94C2.15 0.31 2.85 0 3.59 0C3.87 0 4.15 0.0600001 4.4 0.18C4.66 0.3 4.89 0.48 5.07 0.74L7.39 4.01C7.57 4.26 7.7 4.49 7.79 4.71C7.88 4.92 7.93 5.13 7.93 5.32C7.93 5.56 7.86 5.8 7.72 6.03C7.59 6.26 7.4 6.5 7.16 6.74L6.4 7.53C6.29 7.64 6.24 7.77 6.24 7.93C6.24 8.01 6.25 8.08 6.27 8.16C6.3 8.24 6.33 8.3 6.35 8.36C6.53 8.69 6.84 9.12 7.28 9.64C7.73 10.16 8.21 10.69 8.73 11.22C8.83 11.32 8.94 11.42 9.04 11.52C9.44 11.91 9.45 12.55 9.05 12.95Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9701 16.33C19.9701 16.61 19.9201 16.9 19.8201 17.18C19.7901 17.26 19.7601 17.34 19.7201 17.42C19.5501 17.78 19.3301 18.12 19.0401 18.44C18.5501 18.98 18.0101 19.37 17.4001 19.62C17.3901 19.62 17.3801 19.63 17.3701 19.63C16.7801 19.87 16.1401 20 15.4501 20C14.4301 20 13.3401 19.76 12.1901 19.27C11.0401 18.78 9.8901 18.12 8.7501 17.29C8.3601 17 7.9701 16.71 7.6001 16.4L10.8701 13.13C11.1501 13.34 11.4001 13.5 11.6101 13.61C11.6601 13.63 11.7201 13.66 11.7901 13.69C11.8701 13.72 11.9501 13.73 12.0401 13.73C12.2101 13.73 12.3401 13.67 12.4501 13.56L13.2101 12.81C13.4601 12.56 13.7001 12.37 13.9301 12.25C14.1601 12.11 14.3901 12.04 14.6401 12.04C14.8301 12.04 15.0301 12.08 15.2501 12.17C15.4701 12.26 15.7001 12.39 15.9501 12.56L19.2601 14.91C19.5201 15.09 19.7001 15.3 19.8101 15.55C19.9101 15.8 19.9701 16.05 19.9701 16.33Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 4.67252,
  y1: 0,
  x2: 4.67252,
  y2: 15.0938,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055445"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10F0C6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 13.7851,
  y1: 12.04,
  x2: 13.7851,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055445"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10F0C6",
  stopOpacity: 0
})));

function SvgTelephone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0b56f754918b39e4c7b4959fbf2a5c20.svg";
export { ForwardRef as ReactComponent };